import { useState } from "react";
import Config from "../../Config";
import Correspondents from "./Correspondents";
import Received from "./Received";
import Sended from "./Sended";




function PostView(props)
{

 
    const [refreshView, setRefreshView] = useState(props.userData.refreshView);


  
    if(refreshView != props.userData.refreshView)
    {
        setRefreshView( props.userData.refreshView);
        //getData();
    }


 

      if(props.mainView.viewSelected == 'correspondents')
        {
            document.title ="Korespondeni"; 
            return (
                <div className="econtent ">                                  
                    <Correspondents  userData={props.userData}  mainView={props.mainView} keyListener={props.keyListener}   />
                </div>
            )
        }

 
      if(props.mainView.viewSelected == 'recived')
        {
            document.title ="Odebrane"; 
            return (
                <div className="econtent ">                                  
                    <Received  userData={props.userData}  mainView={props.mainView} keyListener={props.keyListener}   />
                </div>
            )
        }


         if(props.mainView.viewSelected == 'sended')
        {
            document.title ="Wysłane"; 
            return (
                <div className="econtent ">                                  
                    <Sended  userData={props.userData}  mainView={props.mainView} keyListener={props.keyListener}   />
                </div>
            )
        }
  

        return (
        <div className="econtent ">
             PostView - no selected menu position
        </div>
    );
}


export default PostView ;